<template>
    <span class="help-icon" :data-tippy-content="content">&#x003F;</span>
</template>>

<script>
export default {
    name: "help-popup",
    props: ["content"],
 
    mounted() {
        this.$nextTick(() =>
            tippy(this.$el, {
                duration: 0, 
                arrow: false,
                allowHTML: true,
            })
        )
    },
}
</script>>


<style lang="scss" scoped>
.help-icon {
    display: inline-block;
    line-height: 1;
    // padding: 0.5em;
    border-radius: 0.6em;
    border: 1px solid #888;
    width: 1.2em;
    text-align: center;
    color: white;
    background-color: #888;
    font-size: 0.9em;
    margin-left: 0.5em;
}
</style>>